import React, { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import Select from "react-select";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import {
  getAllSellableProducts,
  addSellableProductToExisting,
  addSellableProduct,
} from "../../../api/sellableProduct.service";
import { useForm, SubmitHandler } from "react-hook-form";
import Loader from "../loader/loader";

const AddSellableProduct: React.FC<any> = ({
  subjectId,
  subjectName,
  existingSellableProducts,
  title,
  buttonText,
  confirmAction,
}: {
  confirmAction: (isConfirm: boolean) => void;
  subjectId;
  subjectName: string;
  existingSellableProducts: Array<any>;
  title: string;
  buttonText: string;
}) => {
  type Inputs = {
    newProduct: string;
    existingProduct: string;
  };

  const { register, handleSubmit } = useForm<Inputs>();
  const [isProductDisabled, setIsProductDisabled] = useState<boolean>(true);
  const [isNameDisabled, setIsNameDisabled] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  const defaultProductValue: ISelectElement = {
    label: "Select Product",
    value: "0",
  };
  const [selectedProduct, setSelectedProduct] =
    useState<ISelectElement>(defaultProductValue);
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [isExistingSelected, setIsExistingSelected] = useState<boolean>(false);

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    if (isExistingSelected) {
      addSellableProductToExisting({
        productId: selectedProduct.value,
        subjectIds: subjectId,
      }).then(() => {
        postSuccess();
      });
    } else {
      const product = {
        name: data.newProduct,
        userId: 0,
        subjectIds: subjectId.toString(),
        isApproved: true,
      };
      addSellableProduct(product).then(() => {
        postSuccess();
      });
    }
  };

  const postSuccess = async () => {
    const module = await import("react-toastify");
    module.toast.success("Product added successfully");

    setTimeout(() => {
      confirmAction(true);
    }, 1000);
  };

  function handleProductChange(selectedItem: any) {
    setIsExistingSelected(true);
    setSelectedProduct(selectedItem);
  }

  const fetchProductList = () => {
    setLoading(true);
    getAllSellableProducts().then((products) => {
      const newProductData: Array<any> = [];
      products?.data?.data?.map((product) => {
        if (
          !existingSellableProducts
            .map((ds) => ds.sellableProductId)
            .includes(product.sellableProductId)
        ) {
          newProductData.push({
            value: product.sellableProductId || 0,
            label: product.name,
          });
        }
      });

      setAllProducts(newProductData);
      setLoading(false);
    });
  };

  const handleRadioButtonChange = (type: string) => {
    if (type === "existingProduct") {
      setIsProductDisabled(false);
      setIsNameDisabled(true);
    } else {
      setIsNameDisabled(false);
      setIsProductDisabled(true);
    }
  };

  useEffect(() => {
    fetchProductList();
  }, []);
  return (
    <div>
      {loading && <Loader />}

      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0"
          onClose={() => confirmAction(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4 h-27">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
                  <div className="sm:flex sm:items-start">
                    <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <DialogTitle as="h3" className="text-sm text-gray-700">
                        {title} for
                      </DialogTitle>
                      <p>{subjectName}</p>
                      <div className="mt-2">
                        <div className="grid grid-cols-1 divide-y divide-gray-300 border border-gray-300 rounded-lg ">
                          <div className=" bg-gray-100 h-22 px-4 flex">
                            <div className="flex items-center w-full">
                              <input
                                type="radio"
                                onClick={() =>
                                  handleRadioButtonChange("newProduct")
                                }
                                className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300"
                                name="rbt-sellabele-product"
                              />
                              <div className="w-full py-4">
                                <label className="ml-3 mb-1 block text-sm font-medium text-gray-700">
                                  Name
                                  <input
                                    id="newProduct"
                                    disabled={isNameDisabled}
                                    type="text"
                                    defaultValue=""
                                    className={`${
                                      isNameDisabled ? "bg-gray-100" : ""
                                    } mt-1 block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm w-full dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white`}
                                    {...register("newProduct")}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className=" h-22 px-4 flex w-full">
                            <div className="flex items-center w-full">
                              <input
                                onClick={() =>
                                  handleRadioButtonChange("existingProduct")
                                }
                                type="radio"
                                className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300"
                                name="rbt-sellabele-product"
                              />
                              <div className="w-full py-4">
                                <label className="ml-3 mb-1 block text-sm font-medium text-gray-700">
                                  Add to existing sellable Product
                                  <div className="text-sm mt-1">
                                    <Select
                                      isDisabled={isProductDisabled}
                                      options={allProducts}
                                      value={selectedProduct}
                                      isSearchable={true}
                                      onChange={handleProductChange}
                                      theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                          ...theme.colors,
                                          primary25: "#B3B3B3",
                                          primary: "#041E42",
                                        },
                                      })}
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          background:
                                            document.getElementsByClassName(
                                              "dark"
                                            )?.length > 0
                                              ? "#1A1C23"
                                              : "white",
                                          borderColor:
                                            document.getElementsByClassName(
                                              "dark"
                                            )?.length > 0
                                              ? "#6B7280"
                                              : "#D1D5DB",
                                          borderWidth: "1px",
                                          "&:hover": {
                                            borderColor:
                                              state.isFocused &&
                                              document.getElementsByClassName(
                                                "dark"
                                              )?.length > 0
                                                ? "#6b7280"
                                                : state.isFocused
                                                ? "#4c5563"
                                                : "",
                                          },
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color:
                                            document.getElementsByClassName(
                                              "dark"
                                            )?.length > 0
                                              ? "white"
                                              : "#374051",
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          color:
                                            document.getElementsByClassName(
                                              "dark"
                                            )?.length > 0
                                              ? "#262626"
                                              : "#262626",
                                          marginTop: 0,
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          color:
                                            document.getElementsByClassName(
                                              "dark"
                                            )?.length > 0
                                              ? "white"
                                              : "",
                                        }),
                                      }}
                                      maxMenuHeight={250}
                                    ></Select>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="submit"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      {buttonText}
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() => confirmAction(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default AddSellableProduct;
